<template>
  <div :class="{'mb-4': $page.props.flash.success || $page.props.flash.error}">
    <b-notification type="is-success" v-if="$page.props.flash.success && show">
      {{ $page.props.flash.success }}
    </b-notification>
    <b-notification type="is-danger" v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0) && show">
      <div v-if="$page.props.flash.error">{{ $page.props.flash.error }}</div>
      <div v-else>
        <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
        <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
      </div>
    </b-notification>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
